import { render, staticRenderFns } from "./domesticConfirm.vue?vue&type=template&id=2cc65e9c"
import script from "./domesticConfirm.vue?vue&type=script&lang=js"
export * from "./domesticConfirm.vue?vue&type=script&lang=js"
import style0 from "./domesticConfirm.vue?vue&type=style&index=0&id=2cc65e9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports